module.exports = __webpack_public_path__ + "static/media/IMG_1409.4be469a5.JPG";